import React, { useState, useEffect, useContext } from "react";
import user2 from "../Images/user2.png";
import shoppingbag from "../Images/shoppingbag.png";
import profile from "../Images/profile.png";
import heart from "../Images/heart.png";
import { BsHandbag } from "react-icons/bs";
import { PiHeartStraightThin } from "react-icons/pi";
import { CiUser } from "react-icons/ci";
import { FaUser } from "react-icons/fa6";
import { HiUser } from "react-icons/hi";

import { PiHandbagSimpleThin } from "react-icons/pi";
import { PiHandbagSimpleLight } from "react-icons/pi";
import { PiBagThin } from "react-icons/pi";

import { useHistory } from "react-router-dom";
import { Popover } from "antd";
import TextField from "@mui/material/TextField";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import plusImage1 from "../Images/plusImage1.png";
import minusImage1 from "../Images/minusImage1.png";
import deleteImage from "../Images/deleteImage.png";
import axios from "axios";
import { MyDomain } from "../App";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FormControl from "@mui/material/FormControl";
import { AppContext, useAppContext } from "./../AppContext";
import SearchSection from "./Header2Components/SearchSection";
import Drawer from "@mui/material/Drawer";
import CloseImg from "../Images/CloseImg.png";
import GiftImage from "../Images/GiftImage.png";
import LemaqLogonobackground from "../Images/LemaqLogonobackground.png";

import jwtDecode from "jwt-decode";

import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

import { useTranslation } from "react-i18next";

import CartImage from "../Images/CartImage.png";
import UserImage1 from "../Images/UserImage1.png";
import UserImage2 from "../Images/UserImage2.png";
import HeartImage from "../Images/HeartImage.png";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1920
        ? "90%"
        : window.innerWidth <= 2560
        ? "70%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

const BootstrapDialog2 = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1024
        ? "80%"
        : window.innerWidth <= 1920
        ? "50%"
        : window.innerWidth <= 2560
        ? "50%"
        : window.innerWidth <= 3840
        ? "50%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));
export default function Header2() {
  const handleSuccess = async (credentialResponse) => {
    const decoded = jwtDecode(credentialResponse.credential);
    const data = {
      FirstName: decoded.given_name,
      LastName: decoded.family_name,
      Email: decoded.email,
      DateOfBirth: "", //DateOfBirth,
      Phonenumber: "", //CountryPhoneNumbers?.value + " " + PhoneNumber,
      Password: "",
      Role: "Client",
      ReceiveNotifications: {
        Email: decoded.email, // Optional: can be same as user's email or different
        Phone: "", // Optional: can be same as user's phone or different
      },
    };
    console.log("Google User:", decoded);
    console.log(decoded.email);
    console.log(data);

    try {
      const response = await axios.post(
        `${MyDomain}Users/UserLoginWithGoogle`,
        data
      );
      const decodedToken = jwtDecode(response.data.token);
      setUser(decodedToken); // Store user data in context
      setToken(response.data.token); // Store token in context
      if (response.data.token) {
        // Save token and user data in localStorage
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", decodedToken.role);
        localStorage.setItem("user", JSON.stringify(decodedToken));
        localStorage.setItem("lang", lang);
        setResponseMessage("Data submitted successfully!");
        setWishList(response.data.wishListItems);
        setCartAmount(response.data.cartItems.length);
        setOpenLoginPopOver(false);
        history.push(`/`);
        setEmail("");
        setPassword("");
        setErrorMessage(false);
        setUserExistErr("");
        setOpenMobileDrawer(false);
      }
    } catch (error) {
      console.error("Login error:", error.response?.data || error.message);
      alert("Invalid credentials. Please try again.");
    }
    // You can now send this info to your backend
  };

  const handleError = () => {
    console.error("Login Failed");
  };
  const { t, i18n } = useTranslation();
  const { setUser, setToken } = useAppContext();

  const [OpenMobileDrawer, setOpenMobileDrawer] = useState(false);
  const CloseMobileDrawerFunc = () => {
    setOpenMobileDrawer(!OpenMobileDrawer);
  };
  const [OpenForgotPasswordModal, setOpenForgotPasswordModal] = useState(false);

  const [EmailForgotPassword, setEmailForgotPassword] = useState("");
  const ForgotPasswordFunc = async () => {
    setModalDoneForgotPassword(true);
    try {
      const response = await axios.post(
        `${MyDomain}Users/ForgotPassword`,
        `"${EmailForgotPassword}"`, // Send as raw string with quotes
        {
          headers: {
            "Content-Type": "application/json", // Important to match [FromBody] string
          },
        }
      );
      setEmailForgotPassword("");
      console.log(response.data);
    } catch (err) {
      console.log(err.response?.data);
    }
  };

  const [ModalDoneForgotPassword, setModalDoneForgotPassword] = useState(false);

  function ModalDone() {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialog2
            //onClose={handleClose2}
            aria-labelledby="customized-dialog-title"
            open={ModalDoneForgotPassword}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 10,
                marginRight: 10,
              }}
            >
              <img
                onClick={() => {
                  setModalDoneForgotPassword(false);
                  setOpenForgotPasswordModal(false);
                }}
                src={CloseImg}
                alt={"Expand"}
                style={{ width: 25, height: 25, cursor: "pointer" }}
              />
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(50vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <a>
                  we sent new password to your email, you can change it later.
                </a>

                {/* <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    marginTop: 40,
                  }}
                  onClick={() => {
                    setModalDoneForgotPassword(false);
                  }}
                >
                  <a style={{ fontSize: 14 }}>Send</a>
                </button> */}
              </div>
            </div>
          </BootstrapDialog2>
        </React.Fragment>
      </div>
    );
  }
  function ModalForgotPassword() {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialog2
            //onClose={handleClose2}
            aria-labelledby="customized-dialog-title"
            open={OpenForgotPasswordModal}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 10,
                marginRight: 10,
              }}
            >
              <img
                onClick={() => {
                  setOpenForgotPasswordModal(false);
                }}
                src={CloseImg}
                alt={"Expand"}
                style={{ width: 25, height: 25, cursor: "pointer" }}
              />
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(50vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <a style={{ fontSize: 20, fontWeight: 500, marginBottom: 20 }}>
                  {t("profile.Passwordrecovery")}
                </a>
                <TextField
                  id="standard-basic"
                  label={t("profile.email")}
                  variant="standard"
                  style={{
                    paddingBottom: 30,
                    width: MyWidth <= 1024 ? "90%" : "50%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
                  }}
                  value={EmailForgotPassword}
                  onChange={(e) => setEmailForgotPassword(e.target.value)}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#a1a1aa", // Default color for bottom line
                      opacity: 0.5,
                      borderBottomWidth: "1px", // Thin bottom line
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#a1a1aa", // Keep it gray on hover
                      opacity: 0.8,
                      borderBottomWidth: "1px", // Keep it thin on hover
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#6366f1", // Change to yellow on focus
                      borderBottomWidth: "1px", // Keep it thin when focused
                    },
                    "& .MuiInputBase-root": {
                      //color: "#a1a1aa", // Color of the text in the input field
                      fontSize: "14px", // Set font size of entered value to 14px
                    },
                  }}
                />
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    marginTop: 40,
                  }}
                  onClick={() => {
                    ForgotPasswordFunc();
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.Send")}</a>
                </button>
              </div>
            </div>
          </BootstrapDialog2>
        </React.Fragment>
      </div>
    );
  }
  const ModalMobileFunc = () => {
    return (
      <div
        style={{
          fontFamily: "Droid Arabic Kufi, sans-serif",
        }}
      >
        <Drawer
          // open={OpenMobileDrawer}
          // onClose={CloseMobileDrawerFunc}
          open={OpenLoginPopOver}
          onOpenChange={handleOpenLoginPopOver}
          anchor="bottom"
          PaperProps={{
            style: {
              height: "auto", // Height adjusts to content
              maxHeight: "90vh", // Optional: Limit max height
              overflow: "auto", // Enable scrolling
              padding: "16px",
            },
          }}
        >
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <img
              onClick={() => {
                setOpenLoginPopOver(false);
              }}
              src={CloseImg}
              alt={"Expand"}
              style={{ width: 25, height: 25, cursor: "pointer" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              //justifyContent: "flex-end",
              paddingTop: 20,
              paddingBottom: 30,
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                //width: 350,
              }}
            >
              <p
                style={{
                  paddingTop: 20,
                  fontSize: 22,
                  fontWeight: 500,
                }}
              >
                {t("profile.Login")}
              </p>

              <TextField
                id="standard-basic"
                label={t("profile.email")}
                variant="standard"
                style={{
                  width: "90%",
                  marginTop: 10,
                }}
                value={Email} // Bind the state value to the TextField
                onChange={(e) => setEmail(e.target.value)} // Update state on input change
              />
              {EmailErr ? (
                <div style={{ display: "flex", width: "90%" }}>
                  <a style={{ fontSize: 14, color: "red" }}>
                    Please check your email
                  </a>
                </div>
              ) : (
                <></>
              )}

              <FormControl
                variant="standard"
                style={{ width: "90%", marginTop: 25 }}
              >
                <InputLabel
                  htmlFor="standard-adornment-password"
                  sx={{ fontSize: "15px" }} // Style for the label
                >
                  {t("profile.Password")}
                  {/* Add asterisk to indicate required */}
                </InputLabel>
                <Input
                  id="standard-adornment-password"
                  type={showPassword ? "text" : "password"}
                  value={Password}
                  onChange={(e) => setPassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? (
                          <VisibilityOff fontSize="small" />
                        ) : (
                          <Visibility fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>

              {PasswordErr ? (
                <div style={{ display: "flex", width: "90%" }}>
                  <a style={{ fontSize: 14, color: "red" }}>
                    Please check your password
                  </a>
                </div>
              ) : (
                <></>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  width: "90%",
                }}
              >
                <p
                  style={{
                    marginTop: 10,
                    cursor: "pointer",
                    color: "#dc2626",
                  }}
                  onClick={() => {
                    setOpenForgotPasswordModal(true);
                    setOpenLoginPopOver(false);
                  }}
                >
                  {t("profile.Forgotyourpassword")}
                </p>
              </div>
              <button
                style={{
                  borderWidth: 0,
                  backgroundColor: "#27272a",
                  color: "white",
                  width: "90%",
                  height: 50,
                  marginTop: 20,
                }}
                onClick={() => {
                  Login();
                }}
              >
                {t("profile.Login")}
              </button>
              <a style={{ paddingTop: 10, color: "red", fontSize: 14 }}>
                {UserExistErr}
              </a>
              {ErrorMessage ? (
                <div
                  style={{
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    width: "90%",
                    paddingTop: 10,
                  }}
                >
                  <p style={{ color: "red" }}>Wrong Password</p>
                </div>
              ) : (
                <></>
              )}
              <a style={{ marginTop: 20, fontSize: 16, opacity: 0.6 }}>
                {t("profile.Orloginwith")}{" "}
              </a>

              <div>
                <GoogleOAuthProvider clientId="727336704178-mlu92uctu4socbf03k88iuv91q977ote.apps.googleusercontent.com">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: 20,
                    }}
                  >
                    <GoogleLogin
                      onSuccess={handleSuccess}
                      onError={handleError}
                      theme="filled_blue" // "filled_black" or "outline"
                      size="large" // "small", "medium", "large"
                      text="signin_with" // "signin_with", "signup_with", "continue_with"
                      shape="pill" // "rectangular", "pill", "circle", "square"
                      logo_alignment="left" // "left" or "center"
                      width="250" // Custom width in px
                    />
                  </div>
                </GoogleOAuthProvider>
              </div>
              <button
                style={{
                  borderWidth: 0,
                  backgroundColor: "white",
                  paddingTop: 40,
                  paddingBottom: 40,
                  cursor: "pointer",
                  color: "#6b21a8",
                }}
                onClick={() => {
                  setOpenLoginPopOver(false);
                  setOpenMobileDrawer(false);
                  handleDivClick("Register");
                }}
              >
                {t("profile.Registration")}
              </button>
            </div>
          </div>
        </Drawer>
      </div>
    );
  };
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));
  const lang =
    JSON.parse(localStorage.getItem(JSON.stringify("lang"))) ??
    JSON.stringify("en");

  const handleDivClick2 = (CategoryName, ProductId) => {
    CreateRecently(ProductId);
    history.push(`/product/${ProductId}`);
  };
  const CreateRecently = (IdOfProduct) => {
    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB").split("/").join("-");
    const formattedTime = now.toTimeString().slice(0, 5);
    const data = {
      UserId: user?.userId,
      ProductId: IdOfProduct,
      TheDate: formattedDate,
      TheTime: formattedTime,
    };
    axios
      .post(`${MyDomain}Recently/CreateRecently`, data) // API URL for adding products to the cart
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
        /* Webkit Browsers (Chrome, Safari, Edge) */
        div::-webkit-scrollbar {
          width: 4px;
          height: 4px;
        }
  
        div::-webkit-scrollbar-track {
          background: transparent;
        }
  
        div::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 4px;
        }
  
        div::-webkit-scrollbar-thumb:hover {
          background: #aaa;
        }
  
        div::-webkit-scrollbar-button {
          display: none;
        }
      `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  const { CartAmount, setCartAmount, WishList, setWishList, setLang } =
    useContext(AppContext);

  const history = useHistory();

  const [open1, setOpen1] = useState(false);
  //const [OpenLoginPopOver, setOpenLoginPopOver] = useState(false);
  const { setOpenLoginPopOver, OpenLoginPopOver } = useAppContext();

  const [openCart, setOpenCart] = useState(false);

  const [responseMessage, setResponseMessage] = useState("");

  const [Email, setEmail] = useState("");
  const [EmailErr, setEmailErr] = useState(false);

  const [Password, setPassword] = useState("");
  const [PasswordErr, setPasswordErr] = useState(false);

  const [UserExistErr, setUserExistErr] = useState(false);

  const [showPassword, setShowPassword] = React.useState(false);
  const [ErrorMessage, setErrorMessage] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const Login = async (event) => {
    //event.preventDefault();
    const data = {
      Email: Email,
      Password: Password,
    };
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    regex.test(Email);
    if (regex.test(Email)) {
      setEmailErr(false);
    } else {
      setEmailErr(true);
    }
    if (Password.length >= 2) {
      setPasswordErr(false);
    } else {
      setPasswordErr(true);
    }

    if (!regex.test(Email) || Password.length < 2) {
      return;
    }
    try {
      const response = await axios.post(`${MyDomain}Users/UserLogin`, data);
      const decodedToken = jwtDecode(response.data.token);
      setUser(decodedToken); // Store user data in context
      setToken(response.data.token); // Store token in context
      if (response.data.token) {
        // Save token and user data in localStorage
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", decodedToken.role);
        localStorage.setItem("user", JSON.stringify(decodedToken));
        localStorage.setItem("lang", lang);
        setResponseMessage("Data submitted successfully!");
        setWishList(response.data.wishListItems);
        setCartAmount(response.data.cartItems.length);
        setOpenLoginPopOver(false);
        history.push(`/`);
        setEmail("");
        setPassword("");
        setErrorMessage(false);
        setUserExistErr("");
        setOpenMobileDrawer(false);
        // Redirect based on role
        // if (decodedToken.role === "Teacher") {
        //   history.push("/teacher-dashboard");
        // } else if (decodedToken.role === "Student") {
        //   history.push("/student-dashboard");
        // } else {
        //   alert("Unknown role. Please contact support.");
        // }
      }
    } catch (error) {
      console.error("Login error:", error.response?.data || error.message);
      alert("Invalid credentials. Please try again.");
    }
  };
  useEffect(() => {
    //localStorage.clear();
  }, [CartAmount, WishList]);
  const handleDivClick = (CategoryName) => {
    setOpen1(false);
    history.push(`/${CategoryName}`); // Navigate to the root path
  };

  const handleOpenLoginPopOver = (newOpen) => {
    setOpenLoginPopOver(newOpen);
  };
  const [currentSlide, setCurrentSlide] = useState(0);

  const customContent = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: 350,
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      <p
        style={{
          paddingTop: 20,
          fontSize: 22,
          fontWeight: 500,
        }}
      >
        {t("profile.Login")}
      </p>

      <TextField
        id="standard-basic"
        label={t("profile.email")}
        variant="standard"
        style={{
          width: "90%",
          marginTop: 10,
        }}
        value={Email} // Bind the state value to the TextField
        onChange={(e) => setEmail(e.target.value)} // Update state on input change
      />
      {EmailErr ? (
        <div style={{ display: "flex", width: "90%" }}>
          <a style={{ fontSize: 14, color: "red" }}>Please check your email</a>
        </div>
      ) : (
        <></>
      )}

      <FormControl variant="standard" style={{ width: "90%", marginTop: 25 }}>
        <InputLabel
          htmlFor="standard-adornment-password"
          sx={{ fontSize: "15px" }} // Style for the label
        >
          {t("profile.Password")}
          {/* Add asterisk to indicate required */}
        </InputLabel>
        <Input
          id="standard-adornment-password"
          type={showPassword ? "text" : "password"}
          value={Password}
          onChange={(e) => setPassword(e.target.value)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
              >
                {showPassword ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>

      {PasswordErr ? (
        <div style={{ display: "flex", width: "90%" }}>
          <a style={{ fontSize: 14, color: "red" }}>
            Please check your password
          </a>
        </div>
      ) : (
        <></>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "90%",
        }}
      >
        <p
          style={{
            marginTop: 10,
            cursor: "pointer",
            color: "#dc2626",
          }}
          onClick={() => {
            setOpenForgotPasswordModal(true);
            setOpenLoginPopOver(false);
          }}
        >
          {t("profile.Forgotyourpassword")}
        </p>
      </div>
      <button
        style={{
          borderWidth: 0,
          backgroundColor: "#27272a",
          color: "white",
          width: "90%",
          height: 50,
          marginTop: 20,
        }}
        onClick={() => {
          Login();
        }}
      >
        {t("profile.Login")}
      </button>
      <a style={{ paddingTop: 10, color: "red", fontSize: 14 }}>
        {UserExistErr}
      </a>
      {ErrorMessage ? (
        <div
          style={{
            justifyContent: "flex-end",
            alignItems: "flex-end",
            width: "90%",
            paddingTop: 10,
          }}
        >
          <p style={{ color: "red" }}>Wrong Password</p>
        </div>
      ) : (
        <></>
      )}
      <a style={{ marginTop: 20, fontSize: 16, opacity: 0.6 }}>
        {t("profile.Orloginwith")}
      </a>

      <div>
        <GoogleOAuthProvider clientId="727336704178-mlu92uctu4socbf03k88iuv91q977ote.apps.googleusercontent.com">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 20,
            }}
          >
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={handleError}
              theme="filled_blue" // "filled_black" or "outline"
              size="large" // "small", "medium", "large"
              text="signin_with" // "signin_with", "signup_with", "continue_with"
              shape="pill" // "rectangular", "pill", "circle", "square"
              logo_alignment="left" // "left" or "center"
              width="250" // Custom width in px
            />
          </div>
        </GoogleOAuthProvider>
      </div>
      <button
        style={{
          borderWidth: 0,
          backgroundColor: "white",
          paddingTop: 40,
          paddingBottom: 40,
          cursor: "pointer",
          color: "#6b21a8",
        }}
        onClick={() => {
          setOpenLoginPopOver(false);
          setOpenMobileDrawer(false);
          handleDivClick("Register");
        }}
      >
        {t("profile.Registration")}
      </button>
    </div>
  );
  const [CartData, setCartData] = useState([]);
  const [SaveTotalPrice, setSaveTotalPrice] = useState(0);
  const [SaveTotalPrice2, setSaveTotalPrice2] = useState(0);
  const [CheckBeautyClub, setCheckBeautyClub] = useState(false);
  const [BeautyClubData, setBeautyClubData] = useState("");

  const [Loading, setLoading] = useState(false);

  const [CartData2, setCartData2] = useState([]);
  const GetCartData = async () => {
    setCartData([]);
    setCartData2([]);
    const data = {
      UserId: user?.userId,
    };
    setLoading(true);
    axios
      .post(`${MyDomain}Cart/GetUserCart`, data) // replace with your API URL
      .then((response) => {
        setCartData(response.data);
        console.log(response.data);
        // Extract userCart and products
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;
        console.log(beautyClub);
        // Step 1: Group products by `id` and `discount`
        const groupedProducts = {};

        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }

          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });

        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });

        // Convert object to array
        const result = Object.values(groupedProducts);

        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );
        setLoading(false);

        // Final Output
        setCartData2(result);

        setSaveTotalPrice(total);
        setSaveTotalPrice2(total);
        if (beautyClub !== null) {
          setCheckBeautyClub(true);
          setSaveTotalPrice2(total - (total * beautyClub) / 100);
          setBeautyClubData(beautyClub);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err.response.data);
      });
  };
  // useEffect(() => {
  //   setCartData([]);
  //   const data = {
  //     UserId: user?.userId,
  //   };

  //   axios
  //     .post(`${MyDomain}Cart/GetUserCart`, data) // replace with your API URL
  //     .then((response) => {
  //       setCartData(response.data);
  //       // Extract userCart and products
  //       const userCart = response.data?.userCart || [];
  //       const products = response.data?.products || [];

  //       // Step 1: Group products by `id` and `discount`
  //       const groupedProducts = {};

  //       products.forEach((product) => {
  //         const key = `${product.id}-${product.discount}`;

  //         if (!groupedProducts[key]) {
  //           groupedProducts[key] = {
  //             ...product,
  //             totalQuantity: 0,
  //             totalPrice: 0,
  //             cartIds: [], // To store userCart IDs
  //           };
  //         }

  //         groupedProducts[key].totalQuantity += 1;
  //         groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
  //       });

  //       // Step 2: Map cart items to grouped products using idOfProduct
  //       userCart.forEach((cartItem) => {
  //         Object.keys(groupedProducts).forEach((key) => {
  //           if (groupedProducts[key].id === cartItem.idOfProduct) {
  //             groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
  //           }
  //         });
  //       });

  //       // Convert object to array
  //       const result = Object.values(groupedProducts);

  //       // Step 3: Calculate total price of all products
  //       const total = result.reduce(
  //         (acc, product) => acc + product.totalPrice,
  //         0
  //       );

  //       // Final Output
  //       setCartData2(result);
  //       setSaveTotalPrice(total);
  //     })
  //     .catch((err) => {
  //       console.log(err.response.data);
  //     });
  // }, []);

  const handleClickOpen = async () => {
    setOpenCart(true);
  };
  const handleClose = () => {
    setOpenCart(false);
  };

  const handleDivClick1 = (CategoryName) => {
    history.push(`/${CategoryName}`);
  };
  const [hoverStates, setHoverStates] = useState({}); // Store hover states for each ID
  const handleMouseEnter = (id) => {
    setHoverStates((prev) => ({ ...prev, [id]: true }));
  };

  const handleMouseLeave = (id) => {
    setHoverStates((prev) => ({ ...prev, [id]: false }));
  };

  const CreateProduct2 = (IdOfProduct) => {
    const data = {
      UserId: user?.userId,
      IdOfProduct: IdOfProduct,
      AmountOfProduct: 1, // Default to adding 1 product to the cart
    };
    console.log(data);
    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // API URL for adding products to the cart
      .then((response) => {
        setCartData(response.data);

        // Extract userCart and products
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;

        // Step 1: Group products by `id` and `discount`
        const groupedProducts = {};

        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }

          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });

        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });

        // Convert object to array
        const result = Object.values(groupedProducts);

        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );

        // Final Output
        setCartData2(result);
        setSaveTotalPrice(total);
        setSaveTotalPrice2(total);

        if (beautyClub !== null) {
          setCheckBeautyClub(true);

          setSaveTotalPrice2(total - (total * beautyClub) / 100);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const MinusAmountCart = (TheId, UserId, IdOfProduct) => {
    const data = {
      Id: TheId,
      UserId: UserId,
      IdOfProduct: IdOfProduct,
    };

    console.log(data);
    axios
      .post(`${MyDomain}Cart/MinusAmountCart`, data) // API URL for decrementing the cart amount
      .then((response) => {
        setCartData(response.data);
        // Extract userCart and products
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;

        setCartAmount(userCart.length);

        // Step 1: Group products by `id` and `discount`
        const groupedProducts = {};

        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }

          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });

        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });

        // Convert object to array
        const result = Object.values(groupedProducts);

        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );

        // Final Output
        setCartData2(result);
        setSaveTotalPrice(total);
        setSaveTotalPrice2(total);

        if (beautyClub !== null) {
          setCheckBeautyClub(true);

          setSaveTotalPrice2(total - (total * beautyClub) / 100);
        }
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  const DeleteFromCart = async (
    DelproductId,
    ProductId,
    UserId,
    IdOfProduct
  ) => {
    axios
      .delete(`${MyDomain}Cart/DeleteFromCart`, {
        data: { Id: DelproductId, UserId: UserId, IdOfProduct: IdOfProduct },
      })
      .then((response) => {
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        const beautyClub = response.data?.beautyClub?.discount || null;

        setCartAmount(userCart.length);
        // Step 1: Group products by `id` and `discount`
        const groupedProducts = {};
        products.forEach((product) => {
          const key = `${product.id}-${product.discount}`;

          if (!groupedProducts[key]) {
            groupedProducts[key] = {
              ...product,
              totalQuantity: 0,
              totalPrice: 0,
              cartIds: [], // To store userCart IDs
            };
          }
          groupedProducts[key].totalQuantity += 1;
          groupedProducts[key].totalPrice += product.PriceAfterDiscount || 0;
        });
        // Step 2: Map cart items to grouped products using idOfProduct
        userCart.forEach((cartItem) => {
          Object.keys(groupedProducts).forEach((key) => {
            if (groupedProducts[key].id === cartItem.idOfProduct) {
              groupedProducts[key].cartIds.push(cartItem.id); // Save userCart.id
            }
          });
        });
        // Convert object to array
        const result = Object.values(groupedProducts);

        // Step 3: Calculate total price of all products
        const total = result.reduce(
          (acc, product) => acc + product.totalPrice,
          0
        );

        // Final Output
        setCartData2(result);

        setSaveTotalPrice(total);
        setSaveTotalPrice2(total);

        if (beautyClub !== null) {
          setCheckBeautyClub(true);

          setSaveTotalPrice2(total - (total * beautyClub) / 100);
        }
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const calculateTotalPrice = (price, amount, discount, discountOnEvery) => {
    let total = 0;

    for (let i = 1; i <= amount; i++) {
      if (i % discountOnEvery === 0) {
        // Apply discount to every 'discountOnEvery' item
        total += price * (1 - discount / 100);
      } else {
        // Add full price for non-discounted items
        total += price;
      }
    }

    // Format the total to show decimals only when needed
    const formattedTotal = Number.isInteger(total)
      ? total.toString()
      : parseFloat(total.toFixed(2));

    return formattedTotal;
  };

  const MobileCartDrawer = () => {
    return (
      <>
        <Drawer
          open={openCart}
          onClose={handleClose}
          anchor="bottom"
          PaperProps={{
            style: {
              overflow: "auto", // Enable scrolling
              height: "100vh", // Set height to 100% of the viewport height
            },
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              paddingTop: 20,
              paddingBottom: 30,
              flexDirection: "column",
              fontFamily: "Droid Arabic Kufi, sans-serif",
            }}
          >
            <div
              style={{
                display: "flex",
                paddingBottom: 20,
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                paddingRight: "2%",
                paddingLeft: "2%",
              }}
            >
              <a style={{ fontSize: 20 }}>{t("profile.Cart")}</a>

              <img
                onClick={() => {
                  handleClose();
                }}
                src={CloseImg}
                alt={"Expand"}
                style={{
                  width: 25,
                  height: 25,
                  cursor: "pointer",
                }}
              />
            </div>

            <div
              style={{
                width: "100%",
                paddingBottom: 170,
              }}
            >
              <div
                style={{
                  //height: "100%",
                  overflow: "auto", // Enables scrolling
                  width: "100%",
                }}
              >
                {CartData2.map((product) => {
                  return (
                    <div style={{}}>
                      <div
                        key={product.id}
                        style={{
                          width: "100%",
                          padding: "10px",
                          flexDirection: "row",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            width: "40%",
                          }}
                          onClick={() => {
                            handleClose();
                            handleDivClick2("product", product?.productId);
                          }}
                        >
                          <img
                            src={product?.image}
                            style={{
                              width: "100%",
                              height: "100%",
                              cursor: currentSlide === 0 ? "" : "pointer",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            cursor: "pointer",
                            width: "60%",
                            flexDirection: "column",
                          }}
                          onClick={() => {}}
                        >
                          <p
                            style={{
                              padding: 0,
                              marginBottom: 5,
                              fontSize: 15,
                            }}
                          >
                            {product.name}
                          </p>
                          <p
                            style={{
                              padding: 0,
                              margin: 0,
                              opacity: 0.5,
                              fontSize: 13,
                            }}
                          >
                            {product.productType}
                          </p>
                          <p
                            style={{
                              padding: 0,
                              margin: 0,
                              opacity: 0.5,
                              fontSize: 13,
                            }}
                          >
                            {product.dropDown}
                          </p>
                          {product.isGift === 2 ? (
                            <>
                              <img
                                src={GiftImage}
                                style={{
                                  width: 18,
                                  height: 18,
                                }}
                              />
                            </>
                          ) : (
                            <></>
                          )}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              paddingTop: 10,
                              paddingBottom: 10,
                            }}
                          >
                            {product.discount === 0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  paddingRight: "50%",
                                  flexDirection: "row",
                                }}
                              >
                                {product.priceInsteadOf === 0 ? (
                                  <>
                                    <a
                                      style={{
                                        margin: 0,
                                        //paddingBottom: 5,
                                        fontSize: 15,
                                      }}
                                    >
                                      ₪
                                      {calculateTotalPrice(
                                        product.price,
                                        product.totalQuantity,
                                        product.discount,
                                        product.theDeal
                                      )}
                                    </a>
                                  </>
                                ) : (
                                  <>
                                    <a
                                      style={{
                                        margin: 0,
                                        //paddingBottom: 5,
                                        fontSize: 15,
                                        color: "red",
                                        textDecoration: "line-through",
                                      }}
                                    >
                                      ₪
                                      {calculateTotalPrice(
                                        product.price,
                                        product.totalQuantity,
                                        product.discount,
                                        product.theDeal
                                      )}
                                    </a>
                                    &nbsp;&nbsp;
                                    <a
                                      style={{
                                        margin: 0,
                                        //paddingBottom: 5,
                                        fontSize: 15,
                                      }}
                                    >
                                      ₪
                                      {calculateTotalPrice(
                                        product.priceInsteadOf,
                                        product.totalQuantity,
                                        product.discount,
                                        product.theDeal
                                      )}
                                    </a>
                                  </>
                                )}

                                <a
                                  style={{
                                    fontSize: 12,
                                  }}
                                >
                                  &nbsp;
                                </a>
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  {product.theDeal === 1 ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <a
                                        style={{
                                          margin: 0,
                                          fontSize: 15,
                                          textDecoration: "line-through",
                                        }}
                                      >
                                        ₪{product.price * product.totalQuantity}
                                      </a>
                                      <a
                                        style={{
                                          margin: 0,
                                          fontSize: 15,
                                          color: "red",
                                        }}
                                      >
                                        &nbsp;₪
                                        {(
                                          product.price -
                                          (product.price * product.discount) /
                                            100
                                        ).toFixed(2) * product.totalQuantity}
                                        &nbsp;
                                      </a>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      {product.totalQuantity === 1 ? (
                                        <></>
                                      ) : (
                                        <>
                                          <a
                                            style={{
                                              margin: 0,
                                              fontSize: 15,
                                              textDecoration: "line-through",
                                              color: "black",
                                            }}
                                          >
                                            ₪
                                            {product.price *
                                              product.totalQuantity}
                                            &nbsp;
                                          </a>
                                        </>
                                      )}
                                      <a
                                        style={{
                                          margin: 0,
                                          fontSize: 15,
                                          color:
                                            product.totalQuantity !== 1
                                              ? "red"
                                              : "black",
                                        }}
                                      >
                                        ₪
                                        {calculateTotalPrice(
                                          product.price,
                                          product.totalQuantity,
                                          product.discount,
                                          product.theDeal
                                        )}
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          <div>
                            {product.discount === 0 ? (
                              <></>
                            ) : (
                              <div style={{ display: "flex" }}>
                                <p style={{ margin: 0 }}>
                                  <a
                                    style={{
                                      fontSize: 15,
                                    }}
                                  >
                                    {product.theDeal === 1 ? (
                                      <div>
                                        <p
                                          style={{
                                            backgroundColor: "#6b21a8",
                                            color: "white",
                                            margin: 0,
                                            paddingLeft: 5,
                                            paddingRight: 5,
                                            fontSize: 15,
                                          }}
                                        >
                                          -{product.discount}%
                                        </p>
                                        <a
                                          style={{
                                            fontSize: 12,
                                            margin: 0,
                                          }}
                                        ></a>
                                      </div>
                                    ) : (
                                      <>
                                        <a
                                          style={{
                                            backgroundColor: "#6b21a8",
                                            color: "white",
                                            fontSize: 12,
                                            paddingLeft: 5,
                                            paddingRight: 5,
                                          }}
                                        >
                                          Buy 2 pcs to get -{product.discount}%
                                          off every {product.theDeal}
                                          {product.theDeal === 2
                                            ? "nd"
                                            : "th"}{" "}
                                          item
                                        </a>
                                      </>
                                    )}
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "35%",
                              }}
                            >
                              {product.isGift != 2 ? (
                                <>
                                  <button
                                    title="minus"
                                    style={{
                                      padding: 5,
                                      backgroundColor: "white",
                                      border: "1px solid #e7e5e4",
                                    }}
                                  >
                                    <img
                                      src={minusImage1}
                                      style={{
                                        width: 25,
                                        height: 25,
                                        margin: 0,
                                        cursor:
                                          currentSlide === 0 ? "" : "pointer",
                                      }}
                                      onClick={() => {
                                        MinusAmountCart(
                                          product.cartIds[0],
                                          user?.userId,
                                          product.id
                                        );
                                      }}
                                    />
                                  </button>
                                </>
                              ) : (
                                <div style={{ width: 40 }}></div>
                              )}

                              <p
                                style={{
                                  margin: 0,
                                  paddingRight: 15,
                                  paddingLeft: 15,
                                }}
                              >
                                {product.totalQuantity}
                              </p>
                              {product.isGift != 2 ? (
                                <>
                                  {" "}
                                  <button
                                    type="button" // Prevent default form behavior
                                    title="plus"
                                    style={{
                                      padding: 5,
                                      backgroundColor: "white",
                                      border: "1px solid #e7e5e4",
                                    }}
                                    onClick={() => {
                                      CreateProduct2(product.id);
                                    }}
                                  >
                                    <img
                                      src={plusImage1}
                                      style={{
                                        width: 25,
                                        height: 25,
                                        margin: 0,
                                        cursor:
                                          currentSlide === 0 ? "" : "pointer",
                                      }}
                                    />
                                  </button>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                            {product.isGift != 2 ? (
                              <>
                                <button
                                  title="delete"
                                  style={{
                                    backgroundColor: "white",
                                    border: "0px solid white",
                                  }}
                                >
                                  <img
                                    src={deleteImage}
                                    style={{
                                      width: 20,
                                      height: 20,
                                      margin: 0,
                                      opacity: hoverStates[product.id]
                                        ? 1
                                        : 0.5,
                                    }}
                                    onClick={() => {
                                      DeleteFromCart(
                                        product.id,
                                        product.id,
                                        user?.userId,
                                        product.id
                                      );
                                    }}
                                    onMouseEnter={() =>
                                      handleMouseEnter(product.id)
                                    }
                                    onMouseLeave={() =>
                                      handleMouseLeave(product.id)
                                    }
                                  />
                                </button>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          height: "0.1px",
                          backgroundColor: "#f4f4f5",
                          width: "100%",
                        }}
                      ></div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div
              style={{
                position: "fixed", // Fix the div to the viewport
                bottom: "0", // Stick to the bottom
                left: "0", // Align to the left
                backgroundColor: "white",
                width: "100%",
                height: 170,
              }}
            >
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: 10,
                  direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                }}
              >
                <p style={{ margin: 0, fontSize: 15 }}>
                  {t("profile.Orderprice")}
                </p>
                <p style={{ margin: 0, fontSize: 15 }}>
                  ₪{SaveTotalPrice.toFixed(2)}
                </p>
              </div>

              {CheckBeautyClub ? (
                <>
                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: 10,
                      direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                    }}
                  >
                    <a>{t("profile.Beautyclubdiscount")}</a>
                    <a>{BeautyClubData}%</a>
                  </div>
                </>
              ) : (
                <></>
              )}

              <div
                style={{
                  height: "0.1px",
                  backgroundColor: "#e5e5e5",
                  width: "100%",
                }}
              ></div>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: 10,
                  direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                }}
              >
                <p style={{ margin: 0, fontWeight: "bold", fontSize: 18 }}>
                  {t("profile.Totalamount")}
                </p>

                {CheckBeautyClub ? (
                  <>
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "bold",
                        fontSize: 18,
                      }}
                    >
                      ₪{SaveTotalPrice2.toFixed(2)}
                    </p>
                  </>
                ) : (
                  <>
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "bold",
                        fontSize: 18,
                      }}
                    >
                      ₪{SaveTotalPrice.toFixed(2)}
                    </p>
                  </>
                )}
              </div>
              <div style={{ width: "100%", padding: 10, paddingTop: 20 }}>
                <button
                  style={{
                    backgroundColor: "#27272a",
                    width: "100%",
                    height: 50,
                    color: "white",
                    borderWidth: 0,
                  }}
                  onClick={() => {
                    handleDivClick("checkout");
                  }}
                >
                  {t("profile.Gotopay")}
                </button>
              </div>
            </div>
          </div>
        </Drawer>
      </>
    );
  };
  const WindowCartDrawer = () => {
    return (
      <>
        {Loading ? (
          <></>
        ) : (
          <>
            <React.Fragment>
              <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openCart}
                fullWidth
                maxWidth={false} // Disable Material-UI's default width settings
              >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                  {t("profile.Cart")}
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={(theme) => ({
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                  })}
                >
                  <CloseIcon />
                </IconButton>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                    fontFamily: "Droid Arabic Kufi, sans-serif",
                  }}
                >
                  <div style={{ width: "70%", height: "calc(90vh - 55px)" }}>
                    <div
                      style={{
                        height: "100%",
                        overflow: "auto", // Enables scrolling
                      }}
                    >
                      {CartData2.map((product) => {
                        return (
                          <div style={{}}>
                            <div
                              key={product.id}
                              style={{
                                width: "95%",
                                padding: "10px",
                                flexDirection: "row",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                              onClick={() => {}}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  width: "50%",
                                }}
                                onClick={() => {
                                  handleClose();
                                  handleDivClick2("product", product.productId);
                                }}
                              >
                                <img
                                  src={product.image}
                                  style={{
                                    height: MyWidth <= 1024 ? 50 : 100,
                                    width: "40%",
                                    objectFit: "contain",
                                    cursor: currentSlide === 0 ? "" : "pointer",
                                  }}
                                />
                                <div>
                                  <p
                                    style={{
                                      padding: 0,
                                      marginBottom: 5,
                                      fontSize: 15,
                                    }}
                                  >
                                    {product.name}
                                  </p>
                                  <p
                                    style={{
                                      padding: 0,
                                      margin: 0,
                                      opacity: 0.5,
                                    }}
                                  >
                                    {product.productType}
                                  </p>
                                  <p
                                    style={{
                                      padding: 0,
                                      margin: 0,
                                      opacity: 0.5,
                                    }}
                                  >
                                    {product.dropDown}
                                  </p>
                                  {product.isGift === 2 ? (
                                    <>
                                      <img
                                        src={GiftImage}
                                        style={{
                                          width: 18,
                                          height: 18,
                                        }}
                                      />
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  //backgroundColor: "yellow",
                                  width: "35%",
                                }}
                              >
                                {product.isGift != 2 ? (
                                  <>
                                    <button
                                      title="minus"
                                      style={{
                                        padding: 5,
                                        backgroundColor: "white",
                                        border: "1px solid #e7e5e4",
                                      }}
                                    >
                                      <img
                                        src={minusImage1}
                                        style={{
                                          width: 30,
                                          height: 30,
                                          margin: 0,
                                          cursor:
                                            currentSlide === 0 ? "" : "pointer",
                                        }}
                                        onClick={() => {
                                          MinusAmountCart(
                                            product.cartIds[0],
                                            user?.userId,
                                            product.id
                                          );
                                        }}
                                      />
                                    </button>
                                  </>
                                ) : (
                                  <div style={{ width: 40 }}></div>
                                )}

                                <p
                                  style={{
                                    margin: 0,
                                    paddingRight: 15,
                                    paddingLeft: 15,
                                  }}
                                >
                                  {product.totalQuantity}
                                </p>
                                {product.isGift != 2 ? (
                                  <>
                                    <button
                                      type="button" // Prevent default form behavior
                                      title="plus"
                                      style={{
                                        padding: 5,
                                        backgroundColor: "white",
                                        border: "1px solid #e7e5e4",
                                      }}
                                      onClick={() => {
                                        CreateProduct2(product.id);
                                      }}
                                    >
                                      <img
                                        src={plusImage1}
                                        style={{
                                          width: 30,
                                          height: 30,
                                          margin: 0,
                                          cursor:
                                            currentSlide === 0 ? "" : "pointer",
                                        }}
                                      />
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "15%",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                  }}
                                >
                                  {product.discount === 0 ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        //paddingRight: "50%",
                                      }}
                                    >
                                      {product.priceInsteadOf === 0 ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            width: "100%",
                                            alignItems: "center",
                                          }}
                                        >
                                          <p
                                            style={{
                                              margin: 0,
                                              //paddingBottom: 5,
                                              fontSize: 15,
                                            }}
                                          >
                                            ₪
                                            {calculateTotalPrice(
                                              product.price,
                                              product.totalQuantity,
                                              product.discount,
                                              product.theDeal
                                            )}
                                          </p>
                                        </div>
                                      ) : (
                                        <>
                                          <p
                                            style={{
                                              margin: 0,
                                              //paddingBottom: 5,
                                              fontSize: 15,
                                              color: "red",
                                              textDecoration: "line-through",
                                            }}
                                          >
                                            ₪
                                            {calculateTotalPrice(
                                              product.price,
                                              product.totalQuantity,
                                              product.discount,
                                              product.theDeal
                                            )}
                                          </p>
                                          &nbsp;&nbsp;
                                          <p
                                            style={{
                                              margin: 0,
                                              //paddingBottom: 5,
                                              fontSize: 15,
                                            }}
                                          >
                                            ₪
                                            {calculateTotalPrice(
                                              product.priceInsteadOf,
                                              product.totalQuantity,
                                              product.discount,
                                              product.theDeal
                                            )}
                                          </p>
                                        </>
                                      )}
                                      {/* <a
                                        style={{
                                          fontSize: 12,
                                        }}
                                      >
                                        &nbsp;
                                      </a> */}
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        {product.theDeal === 1 ? (
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <p
                                              style={{
                                                margin: 0,
                                                fontSize: 15,
                                                textDecoration: "line-through",
                                              }}
                                            >
                                              ₪
                                              {product.price *
                                                product.totalQuantity}
                                            </p>
                                            <p
                                              style={{
                                                margin: 0,
                                                fontSize: 15,
                                                color: "red",
                                              }}
                                            >
                                              ₪{product?.totalPrice.toFixed(2)}
                                            </p>
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            {product.totalQuantity === 1 ? (
                                              <></>
                                            ) : (
                                              <>
                                                <p
                                                  style={{
                                                    margin: 0,
                                                    fontSize: 15,
                                                    textDecoration:
                                                      "line-through",
                                                    color: "black",
                                                  }}
                                                >
                                                  ₪
                                                  {product.price *
                                                    product.totalQuantity}
                                                </p>
                                              </>
                                            )}
                                            <p
                                              style={{
                                                margin: 0,
                                                fontSize: 15,
                                                color:
                                                  product.totalQuantity !== 1
                                                    ? "red"
                                                    : "black",
                                              }}
                                            >
                                              ₪
                                              {calculateTotalPrice(
                                                product.price,
                                                product.totalQuantity,
                                                product.discount,
                                                product.theDeal
                                              )}
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                      {product.discount === 0 ? (
                                        <></>
                                      ) : (
                                        <div style={{ display: "flex" }}>
                                          <p style={{ margin: 0 }}>
                                            <a
                                              style={{
                                                fontSize: 15,
                                              }}
                                            >
                                              {product.theDeal === 1 ? (
                                                <div>
                                                  <p
                                                    style={{
                                                      backgroundColor:
                                                        "#6b21a8",
                                                      color: "white",
                                                      margin: 0,
                                                      paddingLeft: 5,
                                                      paddingRight: 5,
                                                      fontSize: 15,
                                                    }}
                                                  >
                                                    -{product.discount}%
                                                  </p>
                                                  <a
                                                    style={{
                                                      fontSize: 12,
                                                      margin: 0,
                                                    }}
                                                  ></a>
                                                </div>
                                              ) : (
                                                <></>
                                              )}
                                            </a>
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>

                                {product.isGift != 2 ? (
                                  <>
                                    <button
                                      title="delete"
                                      style={{
                                        backgroundColor: "white",
                                        border: "0px solid white",
                                      }}
                                    >
                                      <img
                                        src={deleteImage}
                                        style={{
                                          width: 20,
                                          height: 20,
                                          margin: 0,
                                          opacity: hoverStates[product.id]
                                            ? 1
                                            : 0.5,
                                          //opacity: isHovered ? 1 : 0.5,
                                          //transition: "opacity 0.3s ease",
                                        }}
                                        onClick={() => {
                                          DeleteFromCart(
                                            product.id,
                                            product.id,
                                            user?.userId,
                                            product.id
                                          );
                                        }}
                                        onMouseEnter={() =>
                                          handleMouseEnter(product.id)
                                        }
                                        onMouseLeave={() =>
                                          handleMouseLeave(product.id)
                                        }
                                      />
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <div
                              style={{
                                height: "0.1px",
                                backgroundColor: "#f4f4f5",
                                width: "100%",
                              }}
                            ></div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "30%",
                      height: 200,
                      marginLeft: 20,
                      marginRight: 20,
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "#fafafa",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        width: "80%",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: 10,
                        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                      }}
                    >
                      <p style={{ margin: 0, fontSize: 15 }}>
                        {t("profile.Orderprice")}
                      </p>
                      <p style={{ margin: 0, fontSize: 15 }}>
                        ₪{SaveTotalPrice.toFixed(2)}
                      </p>
                    </div>
                    {CheckBeautyClub ? (
                      <>
                        <div
                          style={{
                            flexDirection: "row",
                            display: "flex",
                            width: "80%",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: 10,
                            direction:
                              i18n.resolvedLanguage === "en" ? "" : "rtl",
                          }}
                        >
                          <a>{t("profile.Beautyclubdiscount")}</a>
                          <a>{BeautyClubData}%</a>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    <div
                      style={{
                        height: "0.1px",
                        backgroundColor: "#e5e5e5",
                        width: "80%",
                      }}
                    ></div>

                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        width: "80%",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: 10,
                        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                      }}
                    >
                      <p
                        style={{ margin: 0, fontWeight: "bold", fontSize: 18 }}
                      >
                        {t("profile.Totalamount")}
                      </p>
                      {CheckBeautyClub ? (
                        <>
                          <p
                            style={{
                              margin: 0,
                              fontWeight: "bold",
                              fontSize: 18,
                            }}
                          >
                            ₪{SaveTotalPrice2.toFixed(2)}
                          </p>
                        </>
                      ) : (
                        <>
                          <p
                            style={{
                              margin: 0,
                              fontWeight: "bold",
                              fontSize: 18,
                            }}
                          >
                            ₪{SaveTotalPrice.toFixed(2)}
                          </p>
                        </>
                      )}
                    </div>
                    <div style={{ width: "80%", padding: 10, paddingTop: 20 }}>
                      <button
                        style={{
                          backgroundColor: "#27272a",
                          width: "100%",
                          height: 50,
                          color: "white",
                          borderWidth: 0,
                        }}
                        onClick={() => {
                          handleDivClick("checkout");
                        }}
                      >
                        {t("profile.Gotopay")}
                      </button>
                    </div>
                  </div>
                </div>
              </BootstrapDialog>
            </React.Fragment>
          </>
        )}
      </>
    );
  };
  return (
    <div
      style={{
        paddingLeft: MyWidth <= 1024 ? "2%" : "0%",
        paddingRight: MyWidth <= 1024 ? "2%" : "0%",
        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      {MyWidth <= 1024 ? <>{ModalMobileFunc()}</> : <></>}

      {ModalDone()}
      {ModalForgotPassword()}
      {MyWidth <= 1024 ? <>{MobileCartDrawer()}</> : <>{WindowCartDrawer()}</>}

      <div
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          display: "flex",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            paddingLeft:
              MyWidth <= 1024 ? 0 : i18n.resolvedLanguage === "en" ? 0 : 90,
            paddingRight:
              MyWidth <= 1024 ? 0 : i18n.resolvedLanguage === "en" ? 90 : 0,
          }}
        >
          <SearchSection />
        </div>
        <div
          style={{
            cursor: "pointer",
            padding: 20,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
          onClick={() => {
            handleDivClick("");
          }}
        >
          <img
            src={LemaqLogonobackground}
            alt="logo"
            style={{
              minWidth: MyWidth <= 1024 ? "40px" : "45px", // Adjust the size
              height: MyWidth <= 1024 ? "40px" : "45px", // Adjust the size
              cursor: "pointer",
            }}
          />
          {/* <a style={{ fontSize: "100%" }}>Make Up Logo</a> */}
        </div>

        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {MyWidth <= 1024 ? (
            <></>
          ) : (
            <>
              <Popover
                content={customContent}
                trigger="click"
                open={OpenLoginPopOver}
                onOpenChange={handleOpenLoginPopOver}
                placement="bottomRight"
                arrow={false}
              ></Popover>
            </>
          )}

          {user === null ? (
            <>
              <CiUser
                onClick={() => {
                  handleOpenLoginPopOver(true);
                  // if (MyWidth <= 1024) {
                  //   setOpenMobileDrawer(true);
                  // } else {
                  //   setOpenLoginPopOver(!OpenLoginPopOver);
                  // }
                }}
                size={30}
                style={{
                  marginRight: i18n.resolvedLanguage === "en" ? 15 : 0,
                  marginLeft: i18n.resolvedLanguage === "en" ? 0 : 15,
                  cursor: "pointer",
                }}
              />
            </>
          ) : (
            <>
              <HiUser
                size={32}
                style={{
                  marginRight: i18n.resolvedLanguage === "en" ? 15 : 0,
                  marginLeft: i18n.resolvedLanguage === "en" ? 0 : 15,
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleDivClick("profile");
                }}
              />
            </>
          )}
          {user === null ? (
            <></>
          ) : (
            <>
              {MyWidth <= 1024 ? (
                <></>
              ) : (
                <>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "30px", // Adjust width to fit your design
                      height: "30px", // Adjust height to fit your design
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "row",
                      marginRight: i18n.resolvedLanguage === "en" ? 15 : 0,
                      marginLeft: i18n.resolvedLanguage === "en" ? 0 : 15,
                    }}
                  >
                    <PiHeartStraightThin
                      onClick={() => {
                        // Add your onClick logic here
                        handleDivClick("profile/wish-list");
                      }}
                      size={30}
                      style={{
                        //marginRight: 12,
                        cursor: "pointer",
                        //paddingLeft: i18n.resolvedLanguage === "en" ? 20 : 0,
                      }}
                    />

                    {WishList.length > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-8px",
                          backgroundColor: "black",
                          color: "white",
                          borderRadius: "50%",
                          width: "18px",
                          height: "18px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        {WishList.length}
                      </div>
                    )}
                  </div>
                </>
              )}
            </>
          )}
          <div
            style={{
              position: "relative",
              display: "inline-block",
              width: "30px", // Adjust width to fit your design
              height: "30px", // Adjust height to fit your design
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <PiHandbagSimpleThin
              onClick={async () => {
                if (user === null) {
                } else {
                  await GetCartData();
                  // Add your onClick logic here
                  await handleClickOpen();
                }
              }}
              size={30}
              style={{
                marginTop: 4,
                cursor: user === null ? "" : "pointer",
              }}
            />
            {CartAmount > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "-5px",
                  right: "-8px",
                  backgroundColor: "black",
                  color: "white",
                  borderRadius: "50%",
                  width: "18px",
                  height: "18px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {CartAmount}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
